if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        // this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

        const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
        const isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
        const isFirefox = /Firefox/.test(navigator.userAgent);

        this.form.addEventListener('submit', (event) => {
          const previewDiv = document.getElementById('product-preview');

          event.preventDefault();

          if (previewDiv) {
            if (isChrome) {
              this.createFileInput(previewDiv).then(() => {
                this.onSubmitHandler(event);
              });
            } else {
              this.onSubmitHandler(event);
            }
          } else {
            this.onSubmitHandler(event);
          }
        });

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // Capture design preview
      createFileInput(previewElem) {
        return new Promise((resolve, reject) => {
          function createPreviewInput(proForm, name, value, className) {
            let input = proForm.querySelector(`input[name="${name}"]`);

            if (input) {
              input.value = value;
            } else {
              input = document.createElement('input');
              input.type = 'file';
              input.name = name;
              input.value = value;
              input.className = className;
              proForm.appendChild(input);
            }
          }

          domtoimage
            .toBlob(previewElem)
            .then(function (blob) {
              document.querySelector('.loading-overlay__spinner').classList.remove('hidden');
              const file = new File([blob], 'design-preview.png');
              const dataTransfer = new DataTransfer();
              dataTransfer.items.add(file);

              const proForm = document.querySelector('form[data-type="add-to-cart-form"]');
              createPreviewInput(proForm, 'properties[Design Preview]', '', 'hidden');
              const fileInput = document.querySelector('input[name="properties[Design Preview]"][type="file"]');
              fileInput.files = dataTransfer.files;

              // Help Safari out
              if (fileInput.webkitEntries.length) {
                fileInput.dataset.file = `${dataTransfer.files[0].name}`;
              }
            })
            .then(function () {
              console.log('Done Image');
              document.querySelector('.loading-overlay__spinner').classList.add('hidden');
              resolve();
            });
        });
      }
      // End Capture design preview

      addCustomItems(variantIds) {
        let formData = {
          items: variantIds,
          sections: this.cart.getSectionsToRender().map((section) => section.id),
        };

        const body = JSON.stringify(formData);

        fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.json();
          })
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            // this.cart.renderContents(response);
          })
          .catch((error) => {
            console.error('Error:', error);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              setTimeout(() => {
                window.location = window.routes.cart_url;
              });
            }
          })
          .then((data) => {
            // Custom items
            const customIdTag = this.form.querySelector('#custom-id');
            if (customIdTag) {
              const variantIds = [];
              const variantInputs = this.form.querySelectorAll('.custom-cost__input');

              variantInputs.forEach((item) => {
                const varId = parseInt(item.dataset.id);
                const qty = document.querySelector('[name="quantity"]').value;
                const customId = customIdTag.value;
                if (item.checked) {
                  variantIds.push({
                    quantity: qty,
                    id: varId,
                    properties: {
                      'Custom ID': customId,
                    },
                  });
                }
              });

              if (variantIds.length) {
                this.addCustomItems(variantIds);
              }

              if (customIdTag) {
                var rand = Math.floor(Math.random() * 10000000000 + 1);
                customIdTag.value = rand;
              }
            }
            // End Custom items
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
